import type { ComponentConfig } from '@puckeditor/core';
import { MicrositeTemplate } from '~/model';
import { useRegisterSection } from '~/hooks/useSections';
import DocumentBlockAlpha from '~/editor/templates/alpha/DocumentBlockAlpha';
import DocumentBlockDelta from '~/editor/templates/delta/DocumentBlockDelta';
import DocumentBlockEpsilon from '~/editor/templates/epsilon/DocumentBlockEpsilon';
import DocumentBlockEta from '~/editor/templates/eta/DocumentBlockEta';
import DocumentBlockZeta from '~/editor/templates/zeta/DocumentBlockZeta';
import DocumentBlockBeta from '~/editor/templates/beta/DocumentBlockBeta';

export interface DocumentBlockProps {
	navigation?: boolean;
	template: MicrositeTemplate;
}

export const PUCK_BLOCK_DOCUMENT: ComponentConfig<DocumentBlockProps> = {
	label: 'Document',
	fields: {
		navigation: {
			type: 'radio',
			options: [
				{ label: 'On', value: true },
				{ label: 'Off', value: false },
			],
		},
		template: {
			type: 'radio',
			options: [
				{ label: 'Alpha', value: MicrositeTemplate.ALPHA },
				{ label: 'Beta', value: MicrositeTemplate.BETA },
				{ label: 'Delta', value: MicrositeTemplate.DELTA },
				{ label: 'Epsilon', value: MicrositeTemplate.EPSILON },
				{ label: 'Eta', value: MicrositeTemplate.ETA },
				{ label: 'Zeta', value: MicrositeTemplate.ZETA },
			],
		},
	},
	defaultProps: {
		navigation: true,
		template: MicrositeTemplate.ETA,
	},
	permissions: {
		duplicate: false,
	},
	render(props) {
		return <DocumentBlock {...props} />;
	},
};

export default function DocumentBlock({ navigation = true, template }: DocumentBlockProps) {
	const id = useRegisterSection('documents', 'Documents', navigation);

	let content = <></>;

	if (template === MicrositeTemplate.ALPHA) {
		content = <DocumentBlockAlpha documents={[{ name: 'Survey', url: 'http://google.com' }]} />;
	}
	if (template === MicrositeTemplate.BETA) {
		content = <DocumentBlockBeta documents={[{ name: 'Survey', url: 'http://google.com' }]} />;
	}
	if (template === MicrositeTemplate.DELTA) {
		content = <DocumentBlockDelta documents={[{ name: 'Survey', url: 'http://google.com' }]} />;
	}
	if (template === MicrositeTemplate.EPSILON) {
		content = <DocumentBlockEpsilon documents={[{ name: 'Survey', url: 'http://google.com' }]} />;
	}
	if (template === MicrositeTemplate.ETA) {
		content = <DocumentBlockEta documents={[{ name: 'Survey', url: 'http://google.com' }]} />;
	}
	if (template === MicrositeTemplate.ZETA) {
		content = <DocumentBlockZeta documents={[{ name: 'Survey', url: 'http://google.com' }]} />;
	}

	return <div id={id}>{content}</div>;
}
